/* eslint-disable camelcase */
import { fireUtagEvent } from '@garmin/support-analytics';
import { baseFullUrl } from './url';
import { REGEX_ORMA_URL } from '../config/constants';

const onLinkClick = (payload) => {
  const {

    event_category, event_action, event_label, link,
  } = payload;
  fireUtagEvent({
    event_category, event_action, event_label,
  });
  if (link) window.open(link, '_self');
};

const attachGAEventAttrForAnchors = (faqDetails) => {
  const { content, publishedId, title } = faqDetails;
  const faqContentNode = document.createElement('div');
  faqContentNode.innerHTML = content;
  const allAnchorNodes = Array.from(faqContentNode.getElementsByTagName('a'));
  let formattedContent = content;

  if (allAnchorNodes && allAnchorNodes.length) {
    allAnchorNodes.forEach((aNode) => {
      if (aNode.href.match(REGEX_ORMA_URL)) {
        const { outerHTML } = aNode;
        aNode.setAttribute('@click.prevent', onLinkClick({
          event_category: 'ORMA Entry Point',
          event_action: 'FAQ',
          event_label: `${title} ${publishedId}`,
          page_type: 'ORMA Entry Point',
          link_type: 'FAQ',
          link: aNode.href,
        }));
        formattedContent = formattedContent.replace(outerHTML, aNode.outerHTML);
      }
    });
  }

  return formattedContent;
};

export const attachExpandCollapseAllButton = (faqDetails) => {
  const expandCollapseButton = `
    <div class="sc__article__content__button--container">
      <button class="sc__article__content__button" 
        @click.prevent="$emit('expandCollapseAll', $event)"
        >
      </button>
    </div>
  `;

  const faqContentNode = document.createElement('div');
  faqContentNode.innerHTML = faqDetails;

  if (faqContentNode.getElementsByClassName('GTDisplay').length > 0) {
    faqContentNode.insertAdjacentHTML('afterbegin', expandCollapseButton);
  }

  return faqContentNode.innerHTML;
};

export const parseEmbeddedContent = (faqDetails) => {
  const { contentMap: embeddedContent } = faqDetails;
  let formattedContent = attachGAEventAttrForAnchors(faqDetails);

  formattedContent = attachExpandCollapseAllButton(formattedContent);

  Object.keys(embeddedContent).forEach((faqId) => {
    const faqHrefPattern = new RegExp(`href="${faqId}"`, 'g');
    const faqLinkFormatted = `
      href="${baseFullUrl}/faq/${faqId}"
      @click.prevent="$emit('embedded-faq-click', '${faqId}')"
      data-content-id="${faqId}"
      data-content-type="faq"
    `;
    formattedContent = formattedContent.replace(faqHrefPattern, faqLinkFormatted);
  });

  return formattedContent;
};
